import update from 'immutability-helper'
import { findIndex } from 'lodash-es'
import {
  loadUnapprovedPublications as doLoadUnapprovedPublications,
  approvePublication as doApprovePublication,
} from '../services'

// Actions
const START_LOAD = 'publications/START_LOAD'
const COMPLETE_LOAD = 'publications/COMPLETE_LOAD'
const FAIL_LOAD = 'publications/FAIL_LOAD'
const START_APPROVE = 'publications/START_APPROVE'
const COMPLETE_APPROVE = 'publications/COMPLETE_APPROVE'
const FAIL_APPROVE = 'publications/FAIL_APPROVE'
const RESET = 'publications/RESET'

// Initial state
const initialState = {
  isLoading: false,
  isLoadFailed: false,
  isApproving: false,
  isApproveFailed: false,
  publications: [],
}

// Reducer
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOAD:
      return update(state, {
        $merge: { isLoading: true, isLoadFailed: false },
      })

    case COMPLETE_LOAD:
      return update(state, {
        $merge: {
          isLoading: false,
          publications: action.publications,
        },
      })

    case FAIL_LOAD:
      return update(state, {
        $merge: { isLoading: false, isLoadFailed: true },
      })

    case START_APPROVE:
      return update(state, {
        $merge: { isApproving: true, isApproveFailed: false },
      })

    case COMPLETE_APPROVE: {
      const index = findIndex(state.publications, { id: action.id })
      return update(state, {
        isApproving: { $set: false },
        publications: { $splice: [[index, 1]] },
      })
    }

    case FAIL_APPROVE:
      return update(state, {
        $merge: { isApproving: false, isApproveFailed: true },
      })

    case RESET:
      return update(state, { $merge: initialState })

    default:
      return state
  }
}

// Action creators
const startLoad = () => ({ type: START_LOAD })
const completeLoad = publications => ({ type: COMPLETE_LOAD, publications })
const failLoad = () => ({ type: FAIL_LOAD })
const startApprove = () => ({ type: START_APPROVE })
const completeApprove = id => ({ type: COMPLETE_APPROVE, id })
const failApprove = () => ({ type: FAIL_APPROVE })

export const loadUnapprovedPublications = () => dispatch => {
  dispatch(startLoad())
  const loadPromise = doLoadUnapprovedPublications()

  loadPromise
    .then(publications => dispatch(completeLoad(publications)))
    .catch(() => dispatch(failLoad()))

  return loadPromise
}

export const approvePublication = id => dispatch => {
  dispatch(startApprove())
  const approvePromise = doApprovePublication(id)

  approvePromise
    .then(() => dispatch(completeApprove(id)))
    .catch(() => dispatch(failApprove()))

  return approvePromise
}

export const resetPublications = () => ({ type: RESET })
